<h1 mat-dialog-title>Is this you logging in?</h1>
<div class="container" mat-dialog-content>
  <img src="https://mc-heads.net/avatar/{{auth.user?.uuid}}/100">
  <span class="contents">
    <h2 class="name">{{auth.user?.username}}</h2>
    <b>IP: </b>{{ip.ipAddress}}<br>
    <b>Location: </b>{{ip.cityName}}, {{ip.regionName}}
  </span>
</div>
<div mat-dialog-actions align="end">
  <button (click)="reject()" mat-raised-button color="warn">No!!</button>
  <button (click)="approve()" mat-raised-button color="accent">Yep, that's me.</button>
</div>
